import styles from './styles.scss';
import { SuggestedCategory } from 'models/SuggestedCategory';
import Image from 'components/Shared/Image';
import { BhImageType } from 'models/BhImageType';
import cn from 'classnames';
import { NotifyLink } from 'components/Shared/NotifyLink';

interface OwnProps {
  categoryData: SuggestedCategory;
  onSelect: () => void;
  selected?: boolean;
  txtProducts: string;
}

const PRODUCT_IMAGE_HEIGHT = 50;
const PRODUCT_IMAGE_WIDTH = PRODUCT_IMAGE_HEIGHT;

export default ({ categoryData, onSelect, txtProducts, selected }: OwnProps) => {
  return (
    <NotifyLink
      className={cn(styles.category, selected ? styles.selected : '')}
      url={categoryData.url}
      ticket={categoryData.ticket}
      onClick={onSelect}
    >
      {categoryData.imageGuid === '' && <div className={styles.categoryimage}>&nbsp;</div>}
      {categoryData.imageGuid && (
        <Image
          {...{
            type: BhImageType.Category,
            id: categoryData.imageGuid,
            name: categoryData.imageName,
            height: PRODUCT_IMAGE_HEIGHT,
            width: PRODUCT_IMAGE_WIDTH,
            appearance: 'rounded',
            className: styles.categoryimage,
            alt: categoryData.displayName
          }}
        />
      )}
      <span className={styles.name}>{categoryData.displayName}</span>
      {!categoryData.isFilterCategory && (
        <p className={styles.productcount}>
          {categoryData.productCount} {txtProducts}
        </p>
      )}
    </NotifyLink>
  );
};
